import { Stack } from '@mui/material';
import { FC, useMemo } from 'react';

import { GetBoInvestorProfileIdEndpoint } from '@Common/types/bo/b2b/investor_profile';

import { B2bInvestorProfileShowSicavGridRow } from '@sh4res/bo-common/resources/investor_profile/components/B2bInvestorProfileShowGridWrapper/components/B2bInvestorProfileShowSicavGrid/components/B2bInvestorProfileShowSicavGridRow/B2bInvestorProfileShowSicavGridRow';
import { B2bInvestorProfileSicavGridContainer } from '@sh4res/bo-common/resources/investor_profile/components/B2bInvestorProfileSicavGrid/components/B2bInvestorProfileSicavGridContainer/B2bInvestorProfileSicavGridContainer';

interface Props {
  allocation: GetBoInvestorProfileIdEndpoint['Client']['ResponseBody']['allocations'];
}

export const B2bInvestorProfileShowSicavGrid: FC<Props> = (props) => {
  const { allocation } = props;

  const GridContent = useMemo(
    () =>
      allocation.map((row, index) => (
        <B2bInvestorProfileShowSicavGridRow
          allocation={row}
          isLastRow={index === allocation.length - 1}
        />
      )),
    [allocation],
  );

  return (
    <Stack direction="column" width="100%" spacing={3} padding={'0 10px'}>
      <B2bInvestorProfileSicavGridContainer content={GridContent} />
    </Stack>
  );
};
